import React from "react";

const LastSecond = () => {
	const [date, setDate] = React.useState(new Date());
	const [left, setLeft] = React.useState("");
	const [color, setColor] = React.useState("#bbe693");
	const [leftMsg, setLeftMsg] = React.useState("");
	// const [tmpDate2, setTmpDate2] = React.useState("");

	React.useEffect(() => {
		//
		let cutOff = process.env.REACT_APP_CUT_OFF;
		// let cutOff = "10:00";
		// let cutOffArr = cutOff.split(":");
		let cutOffArr = cutOff.split("");

		// console.log(parseInt(cutOffArr[0] + "" + cutOffArr[1]));
		// console.log(parseInt(cutOffArr[2] + "" + cutOffArr[3]));

		let tmpDate = new Date();
		tmpDate.setHours(parseInt(cutOffArr[0] + "" + cutOffArr[1]));
		tmpDate.setMinutes(parseInt(cutOffArr[2] + "" + cutOffArr[3]));
		tmpDate.setSeconds(0);
		// setTmpDate2(tmpDate);

		//
		var timer = null;
		timer = setInterval(() => {
			let tmpTimer = new Date();
			let e = Math.floor((tmpDate - tmpTimer) / 1000);
			let min = Math.floor(e / 60);
			let sec = e % 60;

			setDate(tmpTimer);
			setLeft(e);

			if (e < 0) {
				setColor("#f6bdc0");
				setLeftMsg(
					min * -1 +
						"min, " +
						sec * -1 +
						"sec today's draw date has <b>closed</b>"
				);
			} else {
				setLeftMsg(min + "min, " + sec + "sec before today's draw date close");
				if (e < 600) {
					setColor("#fad7a0");
				}
			}
		}, 1e3);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<>
			{(date.getDay() === 0 || date.getDay() === 3 || date.getDay() === 6) && (
				<>
					{left < 1800 && left > -900 && (
						<div
							style={{
								padding: "1px 15px",
								marginBottom: 20,
								backgroundColor: color,
							}}
						>
							<p dangerouslySetInnerHTML={{ __html: leftMsg }} />
						</div>
					)}
				</>
			)}
		</>
	);
};

export default LastSecond;
